import { type ApolloError, gql, useQuery } from '@apollo/react-hooks';

export type ProgrammesData = {
  progMode: string[];
  progLevel: string;
};

export type DepartmentProgrammesData = {
  name: string;
  abbr: string;
  plan: {
    applicationDeadline: string;
    status: string;
    programmes: ProgrammesData[];
  };
};

type GetDepartmentsProgrammes = {
  departmentsProgrammes: DepartmentProgrammesData[];
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};

export const useGetDepartmentsProgrammes = (
  entryYear: string,
): GetDepartmentsProgrammes => {
  const { data, loading, error, refetch } = useQuery(
    gql`
      query ($entryYear: String!) {
        departments(entryYear: $entryYear) {
          name
          abbr
          plan {
            applicationDeadline
            status
            programmes {
              progMode
              progLevel
            }
          }
        }
      }
    `,
    {
      variables: { entryYear },
      skip: !entryYear,
      fetchPolicy: 'network-only',
    },
  );

  return {
    departmentsProgrammes: data?.departments ?? [],
    loading,
    error,
    refetch,
  };
};
